import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../../context/ThemeContext';
import ContextualMedia from '../../components/ContextualMedia';
import MarketingScreenshot from '../../components/MarketingScreenshot';

const Tick: React.FC<{ title: string; sub: string; primary: string; secondary: string; accent: string }> = ({ title, sub, primary, secondary, accent }) => (
  <li className="flex items-start gap-3">
    <span className="mt-1 text-base font-extrabold flex-shrink-0" style={{ color: accent }} aria-hidden="true">✓</span>
    <div>
      <h3 className="font-semibold text-base mb-0.5" style={{ color: primary }}>{title}</h3>
      <p className="text-sm leading-relaxed" style={{ color: secondary, textWrap: 'pretty' }}>{sub}</p>
    </div>
  </li>
);

const EventHistory: React.FC = () => {
  const { colors, dsColors } = useTheme();

  const heroPrimary = colors.textPrimary;
  const heroSecondary = colors.textSecondary;

  return (
    <section className="py-16 md:py-24" style={{ backgroundColor: colors.surface }}>
      <div className="container mx-auto px-4 sm:px-6 max-w-6xl">
        <ContextualMedia
          mediaSide="left"
          compactMedia
          media={
            <MarketingScreenshot
              base="snapshots/20261005T052529Z/Events/iOS - Events - Participant Archive"
              alt="RidePulse participant archive showing a cancelled read-only event and a self-archived event with an Unarchive control"
              caption="Your participant history."
            />
          }
        >
          <div className="text-center md:text-left">
            <p className="text-xs sm:text-sm font-bold uppercase tracking-widest mb-3" style={{ color: dsColors.primary }}>
              After the Ride
            </p>
            <h2 className="text-3xl sm:text-4xl font-bold mb-4" style={{ color: heroPrimary, textWrap: 'balance' }}>
              Event History &amp; Archives
            </h2>
            <p className="text-lg leading-relaxed mb-8" style={{ color: heroSecondary, textWrap: 'pretty' }}>
              The archive is yours to keep. Hosts tuck past events out of the dashboard; riders keep joined and cancelled events in their history.
            </p>
            <ul className="space-y-6 text-left">
              <Tick title="Hosted Archive" sub="Hosts archive past events to keep the dashboard clean — restore them anytime or remove them for good." primary={heroPrimary} secondary={heroSecondary} accent={dsColors.primary} />
              <Tick title="Participant History" sub="Keep the events you joined in your own history." primary={heroPrimary} secondary={heroSecondary} accent={dsColors.primary} />
              <Tick title="Your Riding Record" sub="Past events feed the stats on your profile, so your riding history adds up over time." primary={heroPrimary} secondary={heroSecondary} accent={dsColors.primary} />
            </ul>
            <p className="mt-8 flex flex-wrap gap-x-6 gap-y-2 justify-center md:justify-start">
              <Link
                to="/social#public-profiles"
                className="font-semibold hover:underline focus:outline-none focus-visible:ring-2 rounded"
                style={{ color: dsColors.primary, '--tw-ring-color': dsColors.primary } as React.CSSProperties}
              >
                See how your profile tells the story →
              </Link>
              <Link
                to="/help#event-journey"
                className="font-semibold hover:underline focus:outline-none focus-visible:ring-2 rounded"
                style={{ color: dsColors.primary, '--tw-ring-color': dsColors.primary } as React.CSSProperties}
              >
                The event journey in Help →
              </Link>
            </p>
          </div>
        </ContextualMedia>
      </div>
    </section>
  );
};

export default EventHistory;
